import React from 'react';
import { Grid } from '@material-ui/core';
import { Card1, Card2 } from 'components/Card';
import camera from 'imagens/camera-video.png'
import { useDevice } from 'components/DeviceContext.js';

const OpiniaoDosContadores = () => {
    const { isMobile, isLaptop } = useDevice();
    return (
        <Grid container style={{
            justifyContent: isLaptop ? 'space-around' : 'center',
            display: 'flex',
            padding: isMobile ? '1em' : ' 2em 0 5em',

        }}>
            <Grid item xs={12} md={5} lg={5} >
                <h2 style={{
                    color: 'var(--azul-vivido)',
                    fontSize: '2em',
                    fontWeight: '500'
                }}>Opinião dos contadores municipais</h2>
                <p style={{
                    color: 'var(--laranja)',
                    fontSize: '1.6em',
                    fontWeight: '300'
                }}>Veja os vídeos com os depoimentos:</p>
                <p style={{ borderLeft: '2px solid var(--cinza)' }}>

                    <p >
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--azul-vivido)',
                                color: 'var(--azul-vivido)',
                                borderRadius: '0.4em',
                            }}><img  alt="" src={camera} />
                        </span><span style={{
                            backgroundColor: 'var(--azul-vivido)',
                            padding: '0.8em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0'
                        }}>FIA | Maicon Elvis</span>
                    </p>
                    <iframe style={{ padding: '1em', width:isMobile ? '346px' : isLaptop ? '450px': '560px'  }}  width="560" height="315" src="https://www.youtube.com/embed/4Whez1a6rXE?si=6UydOCWKzMDuvNz0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    <p>
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--laranja)',
                                color: 'var(--azul-vivido)',
                                borderRadius: '0.4em',
                            }}><img  alt=""  src={camera} />
                        </span><span style={{
                            backgroundColor: 'var(--laranja)',
                            padding: '0.8em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0'
                        }}>FIA | Dagmando Lopes</span>
                    </p>
                    <iframe style={{ padding: '1em', width:isMobile ? '346px' : isLaptop ? '450px': '560px'  }} height="315" src="https://www.youtube.com/embed/SNx8-lJKa0A?si=-3UN2ZKfFz9My6Ph" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    <p>
                        <span
                            style={{
                                padding: '1em',
                                border: '2px solid var(--azul-vivido)',
                                color: 'var(--azul-vivido)',
                                borderRadius: '0.4em',
                            }}><img alt=""  src={camera} />
                        </span><span style={{
                            backgroundColor: 'var(--azul-vivido)',
                            padding: '0.8em',
                            color: 'var(--branco)',
                            borderRadius: '0 0.4em 0.4em 0'
                        }}>Campanha FIA | Incentivos Locais</span>
                    </p>
                    <iframe style={{ padding: '1em', width:isMobile ? '346px' : isLaptop ? '450px': '560px'  }} height="315" src="https://www.youtube.com/embed/N2O3YWsHEMI?si=zY7lKplQW31okmck" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </p>

            </Grid>
            <Grid item xs={12} md={5} lg={4} >
                <Card1 />
                <Card2 />
            </Grid>
        </Grid>
    );
}

export default OpiniaoDosContadores;
